module.exports = __webpack_public_path__ + "static/media/firm_jeff.b0a02b9a.jpg";